<div class="privacy-bar" *ngIf="showPrivacyBar">
    <div class="privacy-content">
        <p>
            This website uses cookies to ensure content delivery, optimize site performance, and understand visitor
            profiles.
            To learn more about the cookies used on this site, please review our <a href="#"
                (click)="openModal(); $event.preventDefault()">Cookie Policy</a>.
        </p>
    </div>
    <div class="privacy-buttons">
        <button class="btn accept-btn" (click)="acceptCookies()">Accept All Cookies</button>
        <button class="btn reject-btn" (click)="rejectCookies()">Reject All Cookies</button>
        <button class="btn manage-btn" (click)="openModal()">Manage Cookies</button>
    </div>
</div>

<div class="privacy-modal" [class.show]="showModal" (click)="onModalBackdropClick($event)">
    <div class="modal-content">
        <h2>Cookie Policy</h2>
        <div class="modal-body">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-12 col-md-12">
                        <div class="about-content">
                            <p style="color: white;" [innerHtml]="aboutUsPages?.shortText">
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <div class="about-content" style="color: white;">
                            <p style="color: white;" [innerHtml]="aboutUsPages?.fullText">
                            </p>
                        </div>
                    </div>

                    <!-- SMS Disclosures & Consent for Campaign Compliance -->
                    <div class="col-lg-12 col-md-12" style="margin-top: 20px;">
                        <div class="about-content" style="color: white;">
                            <h5 style="color: #3b3771; font-size: 16px; margin-bottom: 8px;">SMS Disclosures & Consent</h5>
                            <p style="color: white; font-size: 13px; line-height: 1.5; margin-bottom: 20px;">
                                Staten Driving School collects and uses your phone number to send appointment reminders, updates, and instruction-related messages. 
                                By providing your phone number and explicitly opting-in, you consent to receive SMS messages from Staten Driving School. Msg & data rates may apply. 
                                Text STOP to cancel at any time. We value your privacy; SMS consent and cell numbers will not be shared with third parties for marketing purposes.
                            </p>
                        </div>
                    </div>
                </div>
                <p>You can choose to accept or reject these cookies at any time by adjusting your preferences.</p>
            </div>
            <div class="modal-buttons">
                <button class="btn accept-btn" (click)="acceptCookies()">Accept All</button>
                <button class="btn reject-btn" (click)="rejectCookies()">Reject All</button>
                <button class="btn close-btn" (click)="closeModal()">Close</button>
            </div>
        </div>
    </div>